/** O token do caminho /convite/<token> ou /recuperar/<token>, ou null se nao tiver cara de token. */
export function tokenDoCaminho(caminho: string, prefixo: '/convite/' | '/recuperar/'): string | null {
  if (!caminho.startsWith(prefixo)) return null;
  const token = caminho.slice(prefixo.length).replace(/\/$/, '');
  return /^[A-Za-z0-9_-]{20,200}$/.test(token) ? token : null;
}
